class LanguagePicker extends HTMLElement {
  constructor() {
    super();
    const countryList = this.querySelector('#country-list');
    const { usTargetUrl, caTargetUrl, enPrefix, frPrefix } = JSON.parse(
      countryList.dataset.urls
    );

    this.countriesData = {
      us: {
        countryDisplay: 'United States ($USD)',
        targetUrl: usTargetUrl,
        languages: [
          {
            display: 'English',
            url: enPrefix,
          },
        ],
      },
      ca: {
        countryDisplay: 'Canada ($CAD)',
        targetUrl: caTargetUrl,
        languages: [
          {
            display: 'English',
            url: enPrefix,
          },
          {
            display: 'French',
            url: frPrefix,
          },
        ],
      },
    };
    this.selectedLanguage = 'English';
    this.selectedCountry = 'us';

    this.querySelector('.modal-trigger').addEventListener('click', (e) => {
      e.preventDefault();
      this.renderCountries();
    });

    const closeButtons = this.querySelectorAll('.modal-close');
    closeButtons.forEach((btn) => {
      btn.addEventListener('click', (e) => {
        e.preventDefault();
        this.closeModal();
      });
    });

    this.querySelector('.modal-overlay').addEventListener('click', (e) => {
      e.preventDefault();
      this.closeModal();
    });

    this.querySelector('.save-language').addEventListener('click', (e) => {
      e.preventDefault();
      this.save();
    });

    // Check if it's the language-picker in theme.liquid so that all instances of {% render 'language-picker' } won't load
    const isTheme = this.getAttribute('istheme');
    if (isTheme) {
      window.addEventListener('load', () => {
        const locationLastChecked = localStorage.getItem('locationLastChecked');
        // TODO: make this a theme setting and not hardcoded
        const expiration = 60*24*60*60*1000;
        const shouldRecheck = !locationLastChecked || new Date().getTime() - locationLastChecked > expiration;
        if (shouldRecheck) {
          // Request to get user location
          fetch(`${window.location.origin}/browsing_context_suggestions.json`)
            .then((response) => {
              if (!response.ok) {
                throw new Error('Request failed');
              }
              return response.json();
            })
            .then(({ detected_values }) => {
              const checkLsCurrency = setInterval(() => {
                const userCountry = detected_values?.country?.handle || 'US';
                const topLevelDomain = new URL(window.location.origin).hostname.split(".").pop();
                const storefrontCountry = topLevelDomain === 'ca' ? 'ca' : 'us';
                //If the user country is different from the storefront country, open country picker
                if (userCountry.toLowerCase() !== storefrontCountry) {
                  this.renderCountries();
                }
                  clearInterval(checkLsCurrency)
              }, 500)
            });
        }
      });
    }

    if (localStorage.getItem('shippingRegion')) {
      this.selectedCountry = localStorage.getItem('shippingRegion');
    }
    const currentUrl = window.location.href;
    const hasPrefix = /\/fr/.test(currentUrl);
    if (hasPrefix) {
      this.selectedCountry = 'ca';
      this.selectedLanguage = 'French';
      localStorage.setItem('shippingRegion', this.selectedCountry);
      this.querySelector('.modal-trigger').innerText = `${
        this.countriesData[this.selectedCountry].countryDisplay
      }`;
    } else {
      const options = countryList.dataset.countries;
      this.countries = ['us'];
      if (options !== '') {
        this.countries = options.split(',');
      }
      //If theres no selected country in local storage, default to the first option, if there are not countries configured default to US.
      this.querySelector('.modal-trigger').innerText = `${
        this.countriesData[this.countries[0]].countryDisplay
      }`;
    }
    if (localStorage.getItem('ls-locale') || this.selectedCountry) {
      DATE_TIME_FORMATS.setLocale(
        `${localStorage.getItem('ls-locale') || 'en'}-${this.selectedCountry.toUpperCase() || 'US'}`,
      );
    }
  }

  createRadioIcon() {
    const iconWrapper = document.createElement('span');
    iconWrapper.classList.add('icon-radio');
    iconWrapper.classList.add('icon');
    // icon icon-radio-unchecked
    const uncheckedIcon = document.createElement('div');
    uncheckedIcon.classList.add('icon-radio-unchecked');
    uncheckedIcon.classList.add('icon');
    uncheckedIcon.setAttribute('aria-hidden', 'true');
    uncheckedIcon.setAttribute('focusable', 'false');
    // icon icon-radio-checked
    const checkedIcon = document.createElement('div');
    checkedIcon.classList.add('icon-radio-checked');
    checkedIcon.classList.add('icon');
    checkedIcon.setAttribute('aria-hidden', 'true');
    checkedIcon.setAttribute('focusable', 'false');
    iconWrapper.appendChild(uncheckedIcon);
    iconWrapper.appendChild(checkedIcon);
    return iconWrapper;
  }

  renderCountries() {
    const menuDrawer = document.getElementById('menu-drawer');
    if (menuDrawer?.style) {
      menuDrawer.style.overflowX = 'visible';
    }
    const countryList = this.querySelector('#country-list');
    const options = countryList.dataset.countries;
    let countries = ['us'];
    if (options !== '') {
      countries = options.split(',');
    }
    countries.forEach((country) => {
      const wrapper = document.createElement('div');
      wrapper.classList.add('country-option-wrapper');
      const radio = this.createRadioInput({ display: country, name: 'country' })
      wrapper.appendChild(radio);
      wrapper.appendChild(this.createRadioIcon());
      wrapper.appendChild(this.createRadioLabel({ display: this.countriesData[country].countryDisplay }));
      countryList.appendChild(wrapper);
      radio.addEventListener('change', () => {
        this.selectedCountry = country;
        this.renderLanguages(country);
      });
    });
    this.querySelector('.modal').classList.add('modal-open');
  }

  unselectLanguagesList() {
    const elements = this.querySelectorAll('.selected');
    elements.forEach((element) => {
      element.classList.remove('selected');
    });
  }

  createRadioInput ({display}) {
    const radio = document.createElement('input');
    radio.type = 'radio';
    radio.name = 'language';
    radio.value = display;
    radio.id = display;
    return radio;
  }

  createRadioLabel({ display }) {
    const label = document.createElement('label');
    label.htmlFor = display;
    label.textContent = display;
    return label;
  }

  renderLanguages(country) {
    this.querySelector('.country-select').classList.add('hidden');
    this.querySelector('.language-select').classList.remove('hidden');
    this.querySelector('.selected-country').textContent =
      this.countriesData[country].countryDisplay;
    const languagesList = this.querySelector('#language-list');
    const languages = this.countriesData[country].languages;
    languages.forEach((lang) => {
      const wrapper = document.createElement('div');
      wrapper.classList.add('language-option-wrapper');
      const radio = this.createRadioInput(lang);
      wrapper.appendChild(radio);
      wrapper.appendChild(this.createRadioIcon());
      wrapper.appendChild(this.createRadioLabel(lang));
      languagesList.appendChild(wrapper);
      radio.addEventListener('change', () => {
        this.selectedLanguage = lang.display;
        this.unselectLanguagesList();
        li.classList.add('selected');
      });
    });
  }

  closeModal() {
    this.querySelector('#language-list').innerHTML = '';
    this.querySelector('#country-list').innerHTML = '';
    this.querySelector('.selected-country').textContent = '';
    this.querySelector('.country-select').classList.remove('hidden');
    this.querySelector('.language-select').classList.add('hidden');
    this.querySelector('.modal').classList.remove('modal-open');
    const menuDrawer = document.getElementById('menu-drawer');
    localStorage.setItem('locationLastChecked', new Date().getTime());
    if (menuDrawer?.style) {
      menuDrawer.style.overflowX = 'hidden';
    }
  }

  removePrefix(baseUrl) {
    return baseUrl.replace('/fr', '');
  }

  save() {
    const selectedCountryObject = this.countriesData[this.selectedCountry];
    if (selectedCountryObject) {
      const languagesArray = selectedCountryObject.languages;
      const currentLanguage = languagesArray.find(
        (lang) => lang.display === this.selectedLanguage
      );
      if (currentLanguage) {
        const lsLocale = currentLanguage.url.replace(/[^a-z]/g, '');
        localStorage.setItem('shippingRegion', this.selectedCountry);
        localStorage.setItem('ls-locale', lsLocale);
        DATE_TIME_FORMATS.setLocale(`${lsLocale || 'en'}-${this.selectedCountry.toUpperCase()}`);
        const urlPrefix = currentLanguage.url;
        const targetUrl = selectedCountryObject.targetUrl;
        let newTabLink = document.createElement('a');
        newTabLink.href = `${targetUrl}${urlPrefix}`;
        newTabLink.target = '_blank';
        document.body.appendChild(newTabLink);
        newTabLink.click();
      }
      this.closeModal();
    }
  }
}
customElements.define('language-picker', LanguagePicker);
